import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from './authentication/authentication.service';
import { FirebaseAuthService } from './firebase/firebase-auth.service';
import { Subscription } from 'rxjs';

interface LocationHistory {
  currentUser: string | null;
  previousUrl: string | null;
  currentUrl: string | null;
}

@Injectable({ providedIn: 'root' })
export class UrlService {
  private locationHistory: LocationHistory = {
    currentUser: null,
    previousUrl: null,
    currentUrl: null,
  };

  private router = inject(Router);
  private location = inject(Location);
  private authenticationService = inject(AuthenticationService);
  private firebaseAuthService = inject(FirebaseAuthService);
  changedUserSubscrition: Subscription | undefined;
  eventsSubscription: Subscription | undefined;
  constructor() {
    this.loadDataFromSessionStorage(
      this.authenticationService.credentials?.username || null
    );
    this.changedUserSubscrition?.unsubscribe();
    this.changedUserSubscrition = this.firebaseAuthService.changedUser.subscribe((user: any) => {
      if (user) {
        this.loadDataFromSessionStorage(user.email);
      } else {
      }
    });
    this.eventsSubscription?.unsubscribe();
    this.eventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (
          !event.url.includes('login') &&
          this.locationHistory.currentUser !== null
        ) {
          this.locationHistory.previousUrl = this.locationHistory.currentUrl;
          this.locationHistory.currentUrl = event.url;
          //if (this.locationHistory.previousUrl) {
          this.locationHistory.currentUser =
            this.authenticationService.credentials?.username || null;
          if (this.authenticationService.credentials?.username) {
            sessionStorage.setItem(
              this.authenticationService.credentials?.username,
              JSON.stringify(this.locationHistory)
            );
          }
        }
      }
    });
  }

  public loadDataFromSessionStorage(user: string | null): void {
    if (user !== null) {
      let locationData: any;

      locationData = sessionStorage.getItem(user);
      if (locationData) {
        locationData = JSON.parse(locationData);

        const currentUrl = locationData.currentUrl;

        const previousUrl = locationData.previousUrl;
        this.locationHistory.currentUser = user;

        if (previousUrl) {
          this.locationHistory.previousUrl = previousUrl;
        }
        if (currentUrl) {
          this.locationHistory.currentUrl = currentUrl;
        }
      }
    }
  }

  public goBack(): void {
    this.location.back();
  }
  public getPreviousUrl(): string | null {
    return this.locationHistory.previousUrl;
  }
  public getCurrentUrl(): string | null {
    return this.locationHistory.currentUrl;
  }
}
